import { useEffect, useState } from "react";
import { fetchCostCenterMasters } from "../Api/ViewCostCenterMaster";
import { Container, Table } from "react-bootstrap";
//import "../Styling/ViewCostCenterMaster.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewCostCenterMaster = () => {
  const [costCenters, setCostCenters] = useState([]);

  useEffect(() => {
    const loadCostCenters = async () => {
      try {
        const data = await fetchCostCenterMasters();
        setCostCenters(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Cost Centers`);
      }
    };

    loadCostCenters();
  }, []);

  return (
    <>
      {/* <Dashboard> */}
        <div className="">
          <Container fluid className="list-container">
            <h2 className="header-list-title header-background">View Cost Center Masters</h2>

            {costCenters.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Cost Center Code</th>
                    <th>Cost Center Name</th>
                    <th>Status</th>
                    <th>Created On Date</th>
                    <th>Created On Time</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {costCenters.map((costCenter, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{costCenter.costCenterCode}</td>
                      <td>{costCenter.costCenterName}</td>
                      <td>{costCenter.status}</td>
                      <td>{moment(costCenter.createdOnDate).format("MMM Do YYYY")}</td>
                      <td>{costCenter.createdOnTime ? moment(costCenter.createdOnTime, "HH:mm:ss").format("LTS") : "-"}</td>
                      <td>{costCenter.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No cost centers found.</p>
            )}
          </Container>
        </div>
      {/* </Dashboard> */}
    </>
  );
};

export default ViewCostCenterMaster;